import { push } from 'modules/gtm/modules/common';

const gtmPushSuccessLogin = () => {
  push({
    event: 'Generic Event',
    event_name: 'login',
    login: {
      event_category: 'account',
      event_action: 'login',
      event_label: 'successful',
    },
  });
};

const gtmPushFailedLogin = (errorMessage?: string) => {
  push({
    event: 'Generic Event',
    event_name: 'login_fail',
    login_fail: {
      error_message: errorMessage || '',
      event_category: 'account',
      event_action: 'login',
      event_label: 'fail',
    },
  });
};

export const gtmLoginModule = {
  gtmPushSuccessLogin,
  gtmPushFailedLogin,
};
